import { useEffect } from 'react';
import { LS_KEY_PENDING_PROMO } from 'common/consts/LocalStorage.const';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { addPromoCode } from 'app/store/reducers/cart.reducer';

// A promo code "parked" for a guest (announcement Apply-offer click or a shared ?promoCode= link)
// until they log in / register. localStorage (not session): the registration flow may continue in
// another tab (email confirmation), and the code must survive it. Applied one-shot: the key is
// removed before dispatch, so a failed attempt never retries on its own.
export const parkPromoCode = (code: string) => localStorage.setItem(LS_KEY_PENDING_PROMO, code);

export const useApplyPendingPromoCode = () => {
  const dispatch = useAppDispatch();
  const authModel = useAppSelector((state) => state.auth.authModel);

  useEffect(() => {
    // Deep-link capture: park the code and strip the param so a refresh doesn't re-park it.
    const url = new URL(window.location.href);
    const code = url.searchParams.get('promoCode');

    if (code) {
      parkPromoCode(code);
      url.searchParams.delete('promoCode');
      window.history.replaceState(null, '', url.toString());
    }
  }, []);

  useEffect(() => {
    if (!authModel) {
      return;
    }

    const pendingCode = localStorage.getItem(LS_KEY_PENDING_PROMO);

    if (pendingCode) {
      localStorage.removeItem(LS_KEY_PENDING_PROMO);
      // Reuses the cart promo-code pipeline; criteria-not-met surfaces in the cart's savedPromo label.
      dispatch(addPromoCode({ code: pendingCode }));
    }
  }, [authModel]);
};
